import React, { useState } from 'react';
import { useEvent } from '../../../../hooks/useEvent';
import { AskRequestStatus } from '@hone-automation/common';

type EventPayload = {
  duration: number;
  field: AskRequestStatus;
};

const withQueueBrowser = <P extends object>(
  WrappedComponent: React.ComponentType<P & { pulseField: AskRequestStatus | null; pulseInProgress: boolean }>
) => {
  return function WithQueueBrowser(props: P) {
    const [pulseInProgress, setPulseInProgress] = useState(false);
    const [pulseField, setPulseField] = useState<AskRequestStatus | null>(null);
    const triggerAnimation = (duration: number) => {
      setPulseInProgress(true);
      const timer = setTimeout(() => setPulseInProgress(false), duration);
      return () => clearTimeout(timer);
    };

    useEvent('onQueueRequestChangeStatus', (payload: EventPayload) => {
      //validate animation depending action
      setPulseField(payload.field);
      triggerAnimation(payload.duration);
    });

    useEvent('onRequestToInProgress', (payload: EventPayload) => {
      //validate animation depending action
      setPulseField(payload.field);
      triggerAnimation(payload.duration);
    });

    useEvent('onQueueRequestResolve', (payload: EventPayload) => {
      //validate animation depending action
      setPulseField('Closed');
      triggerAnimation(payload.duration);
    });

    return <WrappedComponent {...props} pulseField={pulseField} pulseInProgress={pulseInProgress} />;
  };
};

export default withQueueBrowser;
